export default __webpack_public_path__ + "static/media/256.dc10543e.jpg";